import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseRoutingModule } from './course-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxOrgChartModule } from 'ngx-org-chart';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { HighchartsChartModule } from 'highcharts-angular';
import { ViewSlidePopupComponent } from './course/view-slide-popup/view-slide-popup.component';
import { CourseListComponent } from './course/course-list/course-list.component';
import { CourseCrudComponent } from './course/course-crud/course-crud.component';
import { QuestionCategoryCrudComponent } from './question-category/question-category-crud/question-category-crud.component';
import { QuestionCategoryListComponent } from './question-category/question-category-list/question-category-list.component';
import { CourseQuestionCrudComponent } from './course-question/course-question-crud/course-question-crud.component';
import { CourseQuestionListComponent } from './course-question/course-question-list/course-question-list.component';
import { CourseTestListComponent } from './course-test/course-test-list/course-test-list.component';
import { CourseTestCrudComponent } from './course-test/course-test-crud/course-test-crud.component';
import { EmpCourseTestListComponent } from './emp-course-test/emp-course-test-list/emp-course-test-list.component';
import { EmpCourseTestCrudComponent } from './emp-course-test/emp-course-test-crud/emp-course-test-crud.component';
import { ExamAttendComponent } from './emp-course-test/exam-attend/exam-attend/exam-attend.component';
import { ActiveCourseTestListComponent } from './emp-course-test/active-course-test-list/active-course-test-list.component';
import { EmployeeReportComponent } from './emp-course-test/employee-report/employee-report.component';
import { EmployeeReportViewComponent } from './emp-course-test/employee-report-view/employee-report-view.component';
import { CourseReportComponent } from './report/course-report/course-report.component';
import { CourseReportViewComponent } from './report/course-report/course-report-view/course-report-view/course-report-view.component';
import { ConfirmationsPopupComponent } from './emp-course-test/confirmation-popup/confirmations-popup.component';
import { EmployeeCourseAllocationComponent } from './emp-course-test/employee-course-allocation/employee-course-allocation/employee-course-allocation.component';
import { ManageemployeeCourseAllocationComponent } from './emp-course-test/employee-course-allocation/manageemployee-course-allocation/manageemployee-course-allocation.component';


@NgModule({
  declarations: [
    CourseCrudComponent,
    CourseListComponent,
    ViewSlidePopupComponent,
    QuestionCategoryCrudComponent,
    QuestionCategoryListComponent,
    CourseQuestionCrudComponent,
    CourseQuestionListComponent,
    CourseTestListComponent,
    CourseTestCrudComponent,
    EmpCourseTestListComponent,
    EmpCourseTestCrudComponent,
    ExamAttendComponent,
    ActiveCourseTestListComponent,
    EmployeeReportComponent,
    EmployeeReportViewComponent,
    CourseReportComponent,
    CourseReportViewComponent,
    ConfirmationsPopupComponent,
    EmployeeCourseAllocationComponent,
    ManageemployeeCourseAllocationComponent
  ],
  imports: [
    CommonModule,
    CourseRoutingModule,
    PerfectScrollbarModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxOrgChartModule,
  ]
})
export class CourseModule { }
